var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _c(
        "div",
        { staticClass: "searchBox" },
        [
          _vm.isCanAudit
            ? _c(
                "div",
                { staticStyle: { "margin-bottom": "10px" } },
                [
                  (_vm.headerData.status == 5 || _vm.headerData.status == 6) &&
                  _vm.identity == "SUP"
                    ? _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: {
                            disabled: _vm.isUpload ? false : true,
                            size: "mini",
                            type: "primary",
                          },
                          on: { click: _vm.submitData },
                        },
                        [_vm._v("提交")]
                      )
                    : _vm._e(),
                  _vm.headerData.status == 6 &&
                  (_vm.statusView == "C" || _vm.statusView == "OC")
                    ? _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.rectifyData },
                        },
                        [_vm._v("整改完成")]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c("el-card", { staticClass: "box-card" }, [
            _c("table", { staticClass: "table-d" }, [
              _c("tr", [
                _c("td", [_vm._v("评价期")]),
                _c("td", [_vm._v(_vm._s(_vm.headerData.appraisePeriod))]),
                _c("td", [_vm._v("Facility 编号")]),
                _c("td", [_vm._v(_vm._s(_vm.headerData.facilityCode))]),
                _c("td", [_vm._v("Facility 名称")]),
                _c("td", [_vm._v(_vm._s(_vm.headerData.facilityName))]),
                _c("td", [_vm._v("状态")]),
                _c("td", [_vm._v(_vm._s(_vm.headerData.statusView))]),
              ]),
              _c("tr", [
                _c("td", [_vm._v("自评截止日期")]),
                _c("td", [_vm._v(_vm._s(_vm.headerData.closingDate))]),
                _c("td", [_vm._v("整改截止日期")]),
                _c("td", [_vm._v(_vm._s(_vm.headerData.rejectExpireDate))]),
                _c("td"),
                _c("td"),
                _c("td"),
                _c("td"),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "10px", height: "50px" } },
        [
          _c(
            "el-col",
            {
              staticStyle: {
                height: "100%",
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
                color: "#EBB563",
                background: "#FCFCFC",
              },
              attrs: { span: 3 },
            },
            [_vm._v(" 附件 ")]
          ),
          _c(
            "el-col",
            {
              staticStyle: {
                height: "100%",
                display: "flex",
                "align-items": "center",
              },
              attrs: { span: 12 },
            },
            [
              _vm.isCanAudit
                ? _c(
                    "div",
                    [
                      ((_vm.headerData.status == 5 ||
                        _vm.headerData.status == 6) &&
                        _vm.identity == "SUP") ||
                      (_vm.headerData.status == 6 &&
                        (_vm.statusView == "C" || _vm.statusView == "OC"))
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.openFile },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("common.selectFile")) + " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _c(
        "ux-grid",
        {
          ref: "plxTable",
          staticClass: "fileTable",
          attrs: {
            data: _vm.fileTable,
            "max-height": "500",
            "show-overflow": "ellipsis",
            "highlight-current-row": "",
          },
          on: { "selection-change": _vm.selectionChange },
        },
        [
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "附件名称",
              field: "documentName",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.onDownload(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.documentName))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("ux-table-column", {
            attrs: { title: "附件描述", align: "center", field: "docComments" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: scope.row.docComments,
                          placement: "top-start",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "inline-block",
                              maxHeight: "80px",
                              padding: "10px 0px",
                              "box-sizing": "border-box",
                            },
                          },
                          [_vm._v(_vm._s(scope.row.docComments))]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("ux-table-column", {
            attrs: { title: "上传人", align: "center", field: "userName" },
          }),
          _c("ux-table-column", {
            attrs: { title: "上传时间", align: "center", field: "createDate" },
          }),
          ((_vm.headerData.status == 5 || _vm.headerData.status == 6) &&
            _vm.identity == "SUP") ||
          (_vm.headerData.status == 6 &&
            (_vm.statusView == "C" || _vm.statusView == "OC"))
            ? _c("ux-table-column", {
                attrs: { title: "", align: "center", field: "updateDate" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("i", {
                            staticClass: "el-icon-delete",
                            staticStyle: { color: "red" },
                            on: {
                              click: function ($event) {
                                return _vm.delFile(scope.row)
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2759813660
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.dialogVisible
            ? _c("uploadFile", {
                attrs: {
                  headerData: _vm.headerData,
                  tsReckindId: _vm.tsReckindId,
                },
                on: { close: _vm.handleClose },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }